import { useEnv } from '@ecomm/data-env-variables/useEnv'
import { useMicroCopy } from '@ecomm/micro-copy'
import { localStorage } from '@simplisafe/ewok'
import { useState } from 'react'

import { Modal } from '../Modal'
const { get, set } = localStorage

const geoRedirectKey = 'geoRedirectSuggested'

const getBrowserLanguage = (browserLanguage: string) =>
  browserLanguage.toLowerCase() === 'en' ? 'en-US' : browserLanguage

export function CountryRedirectModal() {
  const { locale } = useEnv()

  const showRedirectModal =
    typeof navigator !== 'undefined' &&
    locale !== getBrowserLanguage(navigator.language) &&
    !get(geoRedirectKey)
  const [isRedirectModalVisible, setIsRedirectModalVisible] =
    useState(showRedirectModal)

  const handleClose = () => {
    setIsRedirectModalVisible(false)
    set(geoRedirectKey, true)
  }

  const microcopy = useMicroCopy()

  return (
    <Modal isOpen={isRedirectModalVisible} onRequestClose={handleClose}>
      <div className="prose md:prose-md flex w-full flex-col items-center p-8 px-4 text-center md:max-w-sm md:px-8 md:py-16 lg:max-w-lg lg:p-16">
        <h2 className="mb-4">{microcopy['country-redirect-title']}</h2>
        <p>{microcopy['country-redirect-text']}</p>
        <a
          className="btn btn-solid-primary mt-4 block w-fit min-w-[190px] md:mt-6"
          href={microcopy['country-redirect-link']}
        >
          {microcopy['country-redirect-button-text']}
        </a>
      </div>
    </Modal>
  )
}
